import { render, staticRenderFns } from "./LiteracyRanking.vue?vue&type=template&id=6c760117&scoped=true"
import script from "./LiteracyRanking.vue?vue&type=script&lang=js"
export * from "./LiteracyRanking.vue?vue&type=script&lang=js"
import style0 from "./LiteracyRanking.vue?vue&type=style&index=0&id=6c760117&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c760117",
  null
  
)

export default component.exports